import React, { useState, useEffect } from 'react';
import { FaHome, FaFileUpload, FaShoppingCart, FaList, FaTree, FaShoppingBag, FaFileInvoice, FaUser, FaWarehouse, FaFileAlt, FaUserTie, FaHandHoldingUsd, FaBoxOpen, FaIndustry, FaRulerCombined, FaShip, FaUserFriends, FaFileSignature, FaChartBar, FaBoxes, FaStore, FaCreditCard, FaTools, FaClipboardList, FaTruck, FaBuilding, FaReceipt } from 'react-icons/fa';
import { FaSailboat } from 'react-icons/fa6';
import { IoMdLogOut } from "react-icons/io";
import ptcImage from '../../imagenes/ptc.jpg';
import { logoutAndRedirect } from '../../auth/session';
import { urlApiProd } from '../../vistas/utiles';

const Logout = ({ hover }) => {
    return (
        <div className="logout-container">
            <div className="nav-item d-flex align-items-center user-info">
                {hover ? (
                    <span className="nav-link" style={{ cursor: 'default', textAlign: 'center' }}>
                        {localStorage.getItem('Nombre')}
                    </span>
                ) : (
                    <FaUser className="nav-link" />
                )}
            </div>
            <div className="nav-item">
                <button
                    className="btn btn-outline-danger mt-2 logout-button"
                    onClick={async () => {
                        const refreshToken = localStorage.getItem('refresh_token');
                        if (refreshToken) {
                            try {
                                await fetch(`${urlApiProd}/logout`, {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({ refresh_token: refreshToken })
                                });
                            } catch {
                                // Si falla la revocación remota, igual cerramos local.
                            }
                        }
                        logoutAndRedirect('logout');
                    }}>
                    {hover ? (
                        <span className='nav-link' style={{ cursor: 'default' }}>Cerrar Sesión</span>
                    ) : (
                        <IoMdLogOut />
                    )}
                </button>
            </div>
        </div>
    );
};

const generateID = (label) => {
    return `collapse${label.replace(/\s+/g, '').replace(/[^\w\s]/gi, '')}`;
}

const MenuItem = ({ label, href, onClick, icon }) => {
    const handleClick = () => {
        if (onClick) {
            onClick();
        } else {
            window.location.href = href;
        }
    }

    return (
        <button type="button" className="list-group-item list-group-item-action d-flex align-items-center" id='Menu-Item' onClick={handleClick}>
            <span className="me-2">{icon}</span>
            <span >{label}</span>
        </button>
    )
}

const SubMenu = ({ label, items, icon, expanded, setExpanded }) => {
    const collapseID = generateID(label);
    const isOpen = expanded[collapseID] || false;

    const toggleSubMenu = () => {
        setExpanded(prevState => ({ ...prevState, [collapseID]: !isOpen }));
    };

    return (
        <>
            <button type="button" className="list-group-item list-group-item-action d-flex align-items-center" onClick={toggleSubMenu}>
                <span className="me-2">{icon}</span>
                <span>{label}</span>
            </button>
            <div className={`collapse ${isOpen ? 'show' : ''}`} id={collapseID}>
                {items.map((item, index) => (
                    item.subItems ? (
                        <SubMenu key={index} label={item.label} items={item.subItems} icon={item.icon} expanded={expanded} setExpanded={setExpanded} />
                    ) : (
                        <MenuItem key={index} label={item.label} href={item.href} icon={item.icon} />
                    )
                ))}
            </div>
        </>
    );
};

const Menu = ({ onHoverChange }) => {
    const [hover, setHover] = useState(true);
    const [expanded, setExpanded] = useState({});

    useEffect(() => {
        if (true || !hover) {
            setExpanded({});
        }
    }, [hover]);

    const handleMouseEnter = () => {
        setHover(true);
        onHoverChange(true);
    };

    const handleMouseLeave = () => {
        setHover(true);
        onHoverChange(true)
        //setHover(false);
        //onHoverChange(false);
    };

    return (
        <div className="menu-container"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseEnter}
            style={{ width: hover ? '200px' : '70px', transition: 'width 0.3s', display: 'flex', flexDirection: 'column', height: '100vh' }}>
            <div style={{ padding: 10, backgroundColor: '#fff' }}>
                <img
                    src={ptcImage}
                    alt="PTC"
                    style={{
                        display: 'block',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        width: '100%', // ocupa todo el ancho del contenedor
                        maxWidth: '140px', // opcional: define un tamaño máximo para la imagen
                        height: 'auto' // mantiene la proporción de la imagen
                    }}
                />
            </div>
            <div className="list-group flex-grow-1" style={{ width: '100%', maxHeight: '80vh', overflowY: 'auto' }}>
                <MenuItem label="Inicio" href="/home" icon={<FaHome />} />
                {localStorage.getItem('RolMenu') == 2 || 1 === 1 ? (
                    <SubMenu label="Bookings" items={[
                        { label: 'Solicitudes Internas', href: '/solicitudesinterna', icon: <FaFileAlt /> },
                        { label: 'Gestión de Booking', href: '/solicitudes', icon: <FaFileAlt /> },
                    ]} icon={<FaList />} expanded={expanded} setExpanded={setExpanded} />
                ) : (<div></div>)}
                <SubMenu label="Generar" items={[
                    { label: 'Ordenes Compra', href: '/ordenescompras', icon: <FaShoppingCart /> },
                    { label: 'Proformas Invoice', href: '/proforma', icon: <FaFileAlt /> },
                    { label: 'Invoice', href: '/invoice', icon: <FaFileInvoice /> },
                ]} icon={<FaList />} expanded={expanded} setExpanded={setExpanded} />
                <SubMenu label="Lector" items={[
                    { label: 'Lector Archivos', href: '/file', icon: <FaShoppingCart /> },
                ]} icon={<FaList />} expanded={expanded} setExpanded={setExpanded} />
                <SubMenu label="Registros" items={[
                    { label: 'Almacenes', href: '/almacen', icon: <FaWarehouse /> },
                    { label: 'Carta de crédito', href: '/cartascreditos', icon: <FaCreditCard /> },
                    { label: 'Carriers', href: '/carrier', icon: <FaSailboat /> },
                    { label: 'Clientes', href: '/cliente', icon: <FaUserTie /> },
                    { label: 'FFW', href: '/ffws', icon: <FaUserTie /> },
                    { label: 'IncoTerms', href: '/incoterm', icon: <FaFileSignature /> },
                    { label: 'Línea de Crédito', href: '/lineascreditos', icon: <FaHandHoldingUsd /> },
                    { label: 'Notas Fiscales', href: '/notasfiscale' },
                    {
                        label: 'Productos', href: '#', subItems: [
                            { label: 'Calidades', href: '/calidad', icon: <FaBoxes /> },
                            { label: 'Categorias', href: '/categoria', icon: <FaClipboardList /> },
                            { label: 'Especies', href: '/especie', icon: <FaTree /> },
                            { label: 'Medidas', href: '/medida', icon: <FaRulerCombined /> },
                            { label: 'Productos', href: '/producto', icon: <FaBoxOpen /> }
                        ], icon: <FaIndustry />
                    },
                    { label: 'Payment Terms', href: '/paymentterm', icon: <FaFileSignature /> },
                    { label: 'Proveedores', href: '/proveedores1', icon: <FaBuilding /> },
                    { label: 'Puertos', href: '/puerto', icon: <FaShip /> },
                    { label: 'ShippingDocs', href: '/shippingdoc', icon: <FaFileAlt /> },
                    { label: 'Sub-Clientes', href: '/subcliente', icon: <FaUserFriends /> },
                    { label: 'Tipos de Documentos', href: '/documentos1', icon: <FaFileAlt /> },
                    { label: 'Usuarios', href: '/usuariosVista', icon: <FaUser /> }
                ]} icon={<FaList />} expanded={expanded} setExpanded={setExpanded} />
            </div>
            <Logout hover={hover} />
        </div>
    );
};

export default Menu;
